package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.repository.WhiteboardRepository

/**
 * Use case for closing the whiteboard for all participants.
 * Broadcasts the close action and deactivates the whiteboard.
 */
class CloseWhiteboardForAllUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Closes the whiteboard for all participants.
     *
     * @param tableId The game table ID
     * @param whiteboardId The whiteboard ID
     * @param performedBy The user ID who closed the whiteboard
     * @return Result indicating success or failure
     */
    suspend operator fun invoke(
        tableId: String,
        whiteboardId: String,
        performedBy: String
    ): Result<Unit> {
        // Broadcast the close action first
        whiteboardRepository.broadcastAction(
            tableId = tableId,
            whiteboardId = whiteboardId,
            action = WhiteboardAction.CloseForAll,
            performedBy = performedBy
        ).onFailure {
            return Result.failure(it)
        }

        // Delete action history so the next session starts fresh
        whiteboardRepository.deleteWhiteboardActions(
            whiteboardId = whiteboardId
        ).onFailure {
            return Result.failure(it)
        }

        // Then close the whiteboard
        return whiteboardRepository.closeWhiteboard(
            whiteboardId = whiteboardId
        )
    }
}
